class Projects {

    constructor(_request) {
        this._request = _request;
    }

    list() {
        return this._request.fetch({method: "GET", endpoint: "projects"});
    }
}

export default Projects;
